// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3yKJN","col":"Table_col__1a4-s","fulfillmentStatus":"Table_fulfillmentStatus__11nZG","emailCol":"Table_emailCol__ysf8n"};